/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TenantParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['name', codecString],
    [
        'ssoProviderId',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'sso_provider_id',
    ],
    [
        'abbreviatedName',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'abbreviated_name',
    ],
    ['orderCategory', codecNumber, 'order_category'],
    ['isHidden', codecBoolean, 'is_hidden'],
    ['netloc', codecString],
    ['logoDefaultUrl', codecString, 'logo_default_url'],
    ['logoDarkUrl', codecString, 'logo_dark_url'],
]));
export class Tenant extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TenantParser.decode(input).map(res => new Tenant(res));
    }
    static unsafeDecode(input) {
        return Tenant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantParser.encode(data);
    }
    static schema() {
        return TenantParser.schema();
    }
}
